/**
 * Error, that should not be tracked, handled in any scope
 */
// eslint-disable-next-line import/named
import { ExtendedInfoError } from './ExtendedInfoError';

export class WidgetDebugMessage extends ExtendedInfoError {
    type = 'warning';

    scope = null;

    constructor(message, { code, data, reason } = {}, { type, scope } = {}) {
        super(message, { code, data, reason });
        if (['error', 'warning', 'info', 'debug'].includes(type)) {
            this.type = type;
        }
        this.scope = scope;
        this.name = 'WidgetDebugMessage';
    }
}
